module.exports = __webpack_public_path__ + "img/solar-energy.434561d9.png";